import React from "react";
import {useParams} from "react-router-dom";
import GroupList from "../../Components/GroupList";
import GroupConversation from "../../Components/GroupConversation";
import GroupInfoPanel from "../../Components/GroupInfoPanel";
import {Container, ListColumn, ConversationColumn, InfoColumn} from "./styles";

/**
 * Aba Inbox do Group Manager (layout de 2 colunas):
 * - esquerda: lista dos grupos da campanha (GroupList);
 * - direita: conversa do grupo selecionado (GroupConversation).
 * Ao trocar de campanha (o :id da rota muda sem remontar), limpa a seleção.
 */
const Inbox = () => {
    const {id} = useParams();
    const [selected, setSelected] = React.useState(null);
    const [pinVersion, setPinVersion] = React.useState(0);

    React.useEffect(() => {
        setSelected(null);
    }, [id]);

    return (
        <Container>
            <ListColumn>
                <GroupList
                    selectedId={selected?.id}
                    onSelect={(group) => setSelected(group)}
                />
            </ListColumn>
            <ConversationColumn>
                <GroupConversation key={selected?.id} group={selected} onPinned={() => setPinVersion((v) => v + 1)}/>
            </ConversationColumn>
            <InfoColumn>
                <GroupInfoPanel key={selected?.id} group={selected} pinVersion={pinVersion}/>
            </InfoColumn>
        </Container>
    );
};

export default Inbox;
